/**
 * 许可申请API接口
 */

import apiClient from "./axios";

export const permitRequestApi = {
    /**
     * 获取许可申请列表（分页查询）
     * @param {Object} params - 查询参数
     * @param {number} params.page - 页码，默认1
     * @param {number} params.page_size - 每页数量，默认20
     * @param {string} params.flight_number - 航班号筛选
     * @param {string} params.flight_date_start - 航班日期起始（YYYY-MM-DD格式）
     * @param {string} params.flight_date_end - 航班日期结束（YYYY-MM-DD格式）
     * @param {string} params.status - 状态筛选，多个状态用逗号分隔
     * @param {string} params.departure_airport - 出发机场
     * @param {string} params.arrival_airport - 到达机场
     * @param {string} params.batch_id - 批次号筛选
     * @returns {Promise} API响应
     */
    getPermitRequestList: async (params = {}) => {
        return apiClient.get("/v1/flight-permits", { params });
    },

    /**
     * 获取单个许可申请详情
     * @param {number} id - 许可申请ID
     * @returns {Promise} API响应
     */
    getPermitRequestById: async (id) => {
        return apiClient.get(`/v1/flight-permits/${id}`);
    },

    /**
     * 获取航班的所有许可申请
     * @param {number} flightId - 航班ID
     * @returns {Promise} API响应
     */
    getPermitRequestsByFlight: async (flightId) => {
        return apiClient.get(`/v1/flight-operations/${flightId}/permits`);
    },

    /**
     * 创建许可申请
     * @param {number} flightId - 航班ID
     * @param {Object} data - 许可申请数据
     * @returns {Promise} API响应
     */
    createPermitRequest: async (flightId, data) => {
        return apiClient.post(`/v1/flight-operations/${flightId}/permits`, data);
    },

    /**
     * 更新许可申请
     * @param {number} id - 许可申请ID
     * @param {Object} data - 更新数据
     * @returns {Promise} API响应
     */
    updatePermitRequest: async (id, data) => {
        return apiClient.put(`/v1/flight-permits/${id}`, data);
    },
};

export default permitRequestApi;
